import React from 'react';

const Team = () => {
    return (
      <section className="team section-padding bg-blck">
        <div className="container">
          <div className="row">
            <div className="col-md-5 mb-20">
              <h2 className="section-title text-white">
                <span>Notre équipe</span>
              </h2>
              <hr className="border-1" />
              <p className="section-title2 text-white">
                Rencontrez les talents qui insufflent créativité et expertise à
                chacun de nos projets.
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="team-card mb-30">
                <div className="team-img">
                  <img
                    src="/img/about/2.jpg"
                    alt="Description de l'image"
                    className="w-100"
                  />
                </div>
                <div className="team-content">
                  <h3 className="team-title">Lily Bendavid</h3>
                  <p className="team-text">
                    Responsable Stratégie et Réseaux, Lily Bendavid met son
                    regard créatif au service des projets et des réseaux sociaux
                    de l’entreprise.
                  </p>
                </div>
                <div className="title-box">
                  <h3 className="mb-0">Lily Bendavid</h3>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="team-card mb-30">
                <div className="team-img">
                  <img
                    src="/img/about/1.jpg"
                    alt="Description de l'image"
                    className="w-100"
                  />
                </div>
                <div className="team-content">
                  <h3 className="team-title">Anna Taieb </h3>
                  <p className="team-text">
                    Associée chez Jacob Production avec des années d’expérience
                    en relation client, elle garantit une communication de
                    confiance et un suivi attentif aux projets.
                  </p>
                </div>
                <div className="title-box">
                  <h3 className="mb-0">Anna Taieb </h3>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="team-card mb-30">
                <div className="team-img">
                  <img
                    src="/img/about/3.jpg"
                    alt="Description de l'image"
                    className="w-100"
                  />
                </div>
                <div className="team-content">
                  <h3 className="team-title">Yoel Reboh</h3>
                  <p className="team-text">
                    Photographe, il met son expérience dans la mode et la
                    publicité au service des entreprises, en créant des visuels
                    adaptés à leurs campagnes.
                  </p>
                </div>
                <div className="title-box">
                  <h3 className="mb-0">Yoel Reboh</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
};

export default Team;
